import React from 'react';

function Security() {
  return (
    <div className="min-h-screen">
      <div className="max-w-4xl mx-auto px-4 py-32">
        <h1 className="text-4xl font-bold text-white mb-8">Security</h1>
        
        <div className="space-y-8 text-white/80">
          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">Our Security Commitment</h2>
            <p className="mb-4">
              At Atlas AI, we prioritize the security and privacy of our users' data. We employ industry-standard security measures and best practices to protect your information from unauthorized access, disclosure, alteration, and destruction.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">Data Protection Measures</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>End-to-end encryption for data transmission</li>
              <li>Regular security audits and penetration testing</li>
              <li>Multi-factor authentication</li>
              <li>Secure data centers with 24/7 monitoring</li>
              <li>Regular backup procedures</li>
              <li>Access control and authentication protocols</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">Compliance and Certifications</h2>
            <p className="mb-4">
              We maintain compliance with international security standards and regularly update our security measures to meet evolving threats and requirements. Our security practices align with industry regulations and standards.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">Incident Response</h2>
            <p className="mb-4">
              We have a comprehensive incident response plan in place to quickly address and resolve any security incidents. Our team monitors our systems 24/7 and responds immediately to potential security threats.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">Employee Security</h2>
            <p className="mb-4">
              All employees undergo regular security training and follow strict security protocols. Access to customer data is limited to authorized personnel only, with comprehensive audit trails of all access.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">Infrastructure Security</h2>
            <p>
              Our infrastructure is hosted in secure, enterprise-grade data centers with multiple layers of physical and network security. We regularly update and patch our systems to protect against known vulnerabilities.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default Security;